import { withLayout } from '@larvitu/shared/next/layout';

import { Layout } from '../components';

export const getLayout = withLayout(Layout);
